<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <h3 style="margin-left: 20px">Edit Menu</h3>
                <div class="p-fluid p-formgrid p-grid" style="margin: 20px">
                    <div class="p-fluid p-formgrid p-grid">
                        <!-- Main Menu -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Menu <span class="p-invalid p-error">*</span></label>
                            <InputText v-model="mainmenus" required maxlength="200" placeholder="Enter Menu"
                                :class="{ 'p-invalid': isSubmitted && !mainmenus }" />
                            <small class="p-invalid p-error" v-if="v$.mainmenus.$error">{{
                                v$.mainmenus.$errors[0].$message
                                }}</small>
                        </div>

                        <!-- Main Menu Route -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Route </label>
                            <InputText v-model="menuroute" :disabled="mainmenus == ''" maxlength="200"
                                placeholder="Enter Route" />
                        </div>
                        <!-- User Type -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>User Type <span class="p-invalid p-error">*</span></label>
                            <MultiSelect v-model="menuUsertype" :options="usertypeList" required optionLabel="label"
                                optionValue="value" placeholder="Select Users" class="multiselect-custom">
                            </MultiSelect>
                            <small class="p-invalid p-error" v-if="v$.menuUsertype.$error">{{
                                v$.menuUsertype.$errors[0].$message }}
                            </small>
                        </div>

                        <!-- Type of User -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Type of User</label>
                            <MultiSelect v-model="menuTypeofuser" :disabled="!menuUsertype.includes(3)"
                                :options="typeofuserList" optionLabel="label" optionValue="value"
                                placeholder="Select Users" class="multiselect-custom">
                            </MultiSelect>
                        </div>
                        <!--  Icon Name -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Icon Name</label>
                            <InputText v-model="profileUrl" placeholder="Enter Icon Name" />
                        </div>

                        <!-- Application Type -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Application Type
                                <span class="p-invalid p-error"> *</span></label>
                            <div class="p-field-radiobutton p-mr-4">
                                <RadioButton id="app" name="option" :value="1" v-model="applicationType" />
                                <label for="app" class="p-mr-4">App</label>
                                <RadioButton id="mobile" name="option" :value="2" v-model="applicationType" />
                                <label for="mobile" class="p-mr-4">Web</label>
                                <RadioButton id="both" name="option" :value="3" v-model="applicationType" />
                                <label for="both" class="p-mr-4">Both</label>
                            </div>
                        </div>
                        <!-- status -->
                        <div class="p-field p-col-12 p-md-4">
                            <label>Status</label>
                            <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList"
                                optionLabel="label" placeholder="Select ..." appendTo="body"></Dropdown>
                        </div>

                        <!-- Horizontal Line -->
                        <hr style="width: 100%" />

                        <!-- Dynamically Added Submenus -->
                        <div class="p-col-12" v-for="(submenu, index) in submenus" :key="index">
                            <div class="p-grid p-mt-2">

                                <!-- Sub-menu -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>
                                        <span class="p-mr-2">{{ index + 1 }} -</span>Sub-menu</label>
                                    <InputText v-model="submenu.submenu" required maxlength="200"
                                        :placeholder="'Enter Sub-menu ' + (index + 1)" />
                                </div>

                                <!-- Sub-menu Route -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Route</label>
                                    <InputText v-model="submenu.submenuroute" required maxlength="200"
                                        placeholder="Enter Route" />
                                </div>

                                <!-- User Type -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>User Type </label>
                                    <MultiSelect v-model="submenu.usertype" :options="usertypeList" optionLabel="label"
                                        optionValue="value" placeholder="Select Users" class="multiselect-custom">
                                    </MultiSelect>
                                </div>

                                <!-- Type of User -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Type of User</label>
                                    <MultiSelect v-model="submenu.typeofuser" :disabled="!submenu.usertype.includes(3)"
                                        :options="typeofuserList" optionLabel="label" optionValue="value"
                                        placeholder="Select Users" class="multiselect-custom">
                                    </MultiSelect>
                                </div>

                                <!--  Icon Name -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Icon Name</label>
                                    <InputText v-model="submenu.iconName" placeholder="Enter Icon Name" />
                                </div>
                                <!-- Application Type -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Application Type
                                        <span class="p-invalid p-error"> *</span></label>
                                    <div class="p-field-radiobutton p-mr-4">
                                        <RadioButton id="app" name="option" :value="1"
                                            v-model="submenu.applicationType" />
                                        <label for="app" class="p-mr-4">App</label>
                                        <RadioButton id="mobile" name="option" :value="2"
                                            v-model="submenu.applicationType" />
                                        <label for="mobile" class="p-mr-4">Web</label>
                                        <RadioButton id="both" name="option" :value="3"
                                            v-model="submenu.applicationType" />
                                        <label for="both" class="p-mr-4">Both</label>
                                    </div>
                                </div>

                                <!-- status -->
                                <div class="p-field p-col-12 p-md-4">
                                    <label>Status</label>
                                    <Dropdown id="submenustatus" v-model="submenu.submenustatus"
                                        :options="adminstatusList" optionLabel="label" placeholder="Select ..."
                                        appendTo="body"></Dropdown>
                                </div>
                                <!-- Sub-submenus inside submenus -->
                                <div v-if="submenu.subSubmenus && submenu.subSubmenus.length">
                                    <div class="p-col-12" v-for="(subSub, subIndex) in submenu.subSubmenus"
                                        :key="subIndex">
                                        <div class="p-grid">
                                            <!-- Horizontal Line -->
                                            <hr style="width: 100%" />
                                            <div class="p-col-12 p-text-right">
                                                <Button icon="pi pi-times"
                                                    class="p-button-rounded p-button-black p-button-text"
                                                    @click="submenu.subSubmenus.splice(subIndex, 1)" />
                                            </div>

                                            <!-- Sub-submenu Fields (Same as Submenu) -->
                                            <div class="p-field p-col-12 p-md-4">
                                                <label>{{ subIndex + 1 }} - Sub-submenu</label>
                                                <InputText v-model="subSub.submenu" required maxlength="200"
                                                    :placeholder="'Enter Sub-submenu ' + (subIndex + 1)" />
                                            </div>

                                            <div class="p-field p-col-12 p-md-4">
                                                <label>Route</label>
                                                <InputText v-model="subSub.submenuroute" required maxlength="200"
                                                    placeholder="Enter Route" />
                                            </div>

                                            <div class="p-field p-col-12 p-md-4">
                                                <label>User Type </label>
                                                <MultiSelect v-model="subSub.usertype" :options="usertypeList"
                                                    optionLabel="label" optionValue="value" placeholder="Select Users"
                                                    class="multiselect-custom">
                                                </MultiSelect>
                                            </div>

                                            <div class="p-field p-col-12 p-md-4">
                                                <label>Type of User</label>
                                                <MultiSelect v-model="subSub.typeofuser"
                                                    :disabled="!subSub.usertype.includes(3)" :options="typeofuserList"
                                                    optionLabel="label" optionValue="value" placeholder="Select Users"
                                                    class="multiselect-custom">
                                                </MultiSelect>
                                            </div>

                                            <div class="p-field p-col-12 p-md-4">
                                                <label>Icon Name</label>
                                                <InputText v-model="subSub.iconName" placeholder="Enter Icon Name" />
                                            </div>

                                            <div class="p-field p-col-12 p-md-4">
                                                <label>Application Type
                                                    <span class="p-invalid p-error"> *</span></label>
                                                <div class="p-field-radiobutton p-mr-4">
                                                    <RadioButton id="app" name="subsub-option" :value="1"
                                                        v-model="subSub.applicationType" />
                                                    <label for="app" class="p-mr-4">App</label>
                                                    <RadioButton id="mobile" name="subsub-option" :value="2"
                                                        v-model="subSub.applicationType" />
                                                    <label for="mobile" class="p-mr-4">Web</label>
                                                    <RadioButton id="both" name="subsub-option" :value="3"
                                                        v-model="subSub.applicationType" />
                                                    <label for="both" class="p-mr-4">Both</label>
                                                </div>
                                            </div>

                                            <div class="p-field p-col-12 p-md-4">
                                                <label>Status</label>
                                                <Dropdown id="submenustatus" v-model="subSub.submenustatus"
                                                    :options="adminstatusList" optionLabel="label"
                                                    placeholder="Select ..." appendTo="body"></Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Sub- subMenu -->
                                <Button label="Add Sub-submenu" icon="pi pi-plus" class="p-button-text"
                                    @click="addSubSubmenu(index)" />
                            </div>
                            <!-- Horizontal Line -->
                            <hr style="width: 100%" />
                        </div>

                        <!-- Add Sub-menu Button -->
                        <Button label="Add Sub-menu" icon="pi pi-plus" class="p-button-text" @click="addSubmenu" />
                        <!-- <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="resetForm" /> -->
                    </div>

                    <!-- Footer Buttons -->
                    <Button label="Submit" icon="pi pi-check" class="p-button-text p-ml-auto" @click="updateMenu"
                        style="width: 90px"></Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../../service/ApiService";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

export default {
    data() {
        return {
            v$: useValidate(),
            mainmenus: "",
            menuroute: "",
            menuUsertype: [],
            menuTypeofuser: [],
            applicationType: 1,
            subSubmenus: [],
            submenus: [],
            isSubmitted: false,
            showLoader: true,
            subMenusId: [],
            subSubMenuId: [],
            profileUrl: "",
            menuId: '', // Store the menu ID
            usertypeList: [
                { label: "Admin", value: 1 },
                { label: "Host User", value: 2 },
                { label: "Law User", value: 3 },
            ],
            typeofuserList: [
                { label: "Citizen", value: 0 },
                { label: "Police", value: 1 },
                { label: "Employer", value: 2 },
                { label: "Property Owner", value: 3 },
            ],
            adminstatus: { label: 'Active', value: 1 },
            submenustatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
        };
    },
    validations() {
        return {
            mainmenus: {
                required: helpers.withMessage("Please enter Menu name", required),
            },
            applicationType: {
                required: helpers.withMessage("Please select application type", required),
            },
            menuUsertype: {
                required: helpers.withMessage("Please select user type", required),
            },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.menuId = this.$route.params.id; // Get menu ID from URL
        if (this.menuId) {
            setTimeout(() => {
                this.fetchMenuDetails();
            }, 100)
        }
    },
    methods: {
        addSubSubmenu(submenuIndex) {
            if (!this.submenus[submenuIndex].subSubmenus) {
                this.submenus[submenuIndex].subSubmenus = []; // Initialize array if not exists
            }
            this.submenus[submenuIndex].subSubmenus.push({
                submenu: "",
                submenuroute: "",
                usertype: [],
                typeofuser: [],
                iconName: "",
                applicationType: 1,
            });
        },
        async fetchMenuDetails() {
            this.showLoader = true;
            try {
                const response = await this.ApiService.getClientMenusById({ "mbj1": this.menuId });

                if (response.status === 200) {
                    let menuData = response.data[0]; // First menu item
                    this.mainmenus = menuData.label;
                    this.menuroute = menuData.mbj9;
                    this.adminstatus = this.adminstatusList.find(item => item.value === menuData.mbj4);
                    this.menuUsertype = menuData.mbj5 ? menuData.mbj5.split(",").map(Number) : [];
                    this.menuTypeofuser = menuData.mbj6 ? menuData.mbj6.split(",").map(Number) : [];
                    this.applicationType = menuData.mbj8;
                    this.profileUrl = menuData.mbj10 || null;
                    this.subMenusId = menuData.children.map(menu => menu.key);
                    this.subSubMenuId = menuData.children.map(menu => menu.sub_children.map(submenu => submenu.key));

                    // Extract Submenus
                    if (Array.isArray(menuData.children) && menuData.children.length > 0) {
                        this.submenus = menuData.children.map(submenu => {
                            let subSubmenus = [];
                            // Ensure sub_children exists and is an array
                            if (Array.isArray(submenu.sub_children)) {
                                subSubmenus = submenu.sub_children.map(subsub => ({
                                    submenu: subsub.label,
                                    submenuroute: subsub.mbj9,
                                    submenustatus: this.adminstatusList.find(item => item.value === subsub.mbj4),
                                    usertype: subsub.mbj5 ? subsub.mbj5.split(",").map(Number) : [],
                                    typeofuser: subsub.mbj6 ? subsub.mbj6.split(",").map(Number) : [],
                                    iconName: subsub.mbj10,
                                    applicationType: subsub.mbj8
                                }));
                            }

                            return {
                                submenu: submenu.label,
                                submenuroute: submenu.mbj9,
                                usertype: submenu.mbj5 ? submenu.mbj5.split(",").map(Number) : [],
                                typeofuser: submenu.mbj6 ? submenu.mbj6.split(",").map(Number) : [],
                                iconName: submenu.mbj10,
                                applicationType: submenu.mbj8,
                                submenustatus: this.adminstatusList.find(item => item.value === submenu.mbj4),
                                subSubmenus: subSubmenus // Assign only once, preventing duplication
                            };
                        });
                    } else {
                        this.submenus = [];
                    }
                }
            } catch (error) {
                console.error("Error fetching menu details:", error);
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Failed to load menu details. Please try again.",
                    life: 3000,
                });
            } finally {
                this.showLoader = false;
            }
        },

        async updateMenu() {
            this.isSubmitted = true;
            this.v$.$validate();
            if (this.v$.$error) return;

            let formData = new FormData();
            let formattedMenuUsertype = this.menuUsertype.join(",");
            let formattedMenuTypeofuser = this.menuTypeofuser.join(",");

            // Build submenus in required format
            let formattedChildModule = {};
            this.submenus.forEach((submenu, index) => {
                let formattedSubmenu = {
                    mbj1: this.subMenusId[index],
                    mbj2: submenu.submenu,
                    mbj4: submenu.submenustatus?.value,
                    mbj5: submenu.usertype.join(","),
                    mbj6: submenu.typeofuser.join(","),
                    mbj8: submenu.applicationType,
                    mbj9: submenu.submenuroute,
                    mbj10: submenu.iconName,
                    subChildModule: {} // Now track sub-submenus properly
                };
                if (submenu.subSubmenus && submenu.subSubmenus.length > 0) {
                    submenu.subSubmenus.forEach((subsub, subIndex) => {
                        formattedSubmenu.subChildModule[subIndex] = {
                            mbj1: this.subSubMenuId[index][subIndex],
                            mbj2: subsub.submenu,
                            mbj4: subsub.submenustatus?.value,
                            mbj5: subsub.usertype.join(","),
                            mbj6: subsub.typeofuser.join(","),
                            mbj8: subsub.applicationType,
                            mbj9: subsub.submenuroute,
                            mbj10: subsub.iconName,
                        };
                    });
                }

                formattedChildModule[index] = formattedSubmenu;
            });

            // Main payload formatting
            formData.append("mbj1", this.menuId); // Include menu ID
            formData.append("parantModule", this.mainmenus);
            formData.append("mbj9", this.menuroute);
            formData.append("mbj4", this.adminstatus.value);
            formData.append("mbj5", formattedMenuUsertype);

            if (formattedMenuUsertype.includes("3")) {
                formData.append("mbj6", formattedMenuTypeofuser ? formattedMenuTypeofuser : "0");
            }

            formData.append("mbj7", 0);
            formData.append("mbj8", this.applicationType);
            formData.append("mbj10", this.profileUrl);
            formData.append("childModule", JSON.stringify(formattedChildModule));

            this.showLoaderAddBtn = true;
            this.ApiService.insertOrUpdateClientMenus(formData).then((items) => {
                if (items.status === 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: items.message,
                        life: 3000,
                    });
                    this.$router.push('/listing/menus');
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: items.message,
                        life: 3000,
                    });
                }
                this.showLoaderAddBtn = false;
            });
        },
        addSubmenu() {
            this.submenus.push({
                submenu: "",
                submenuroute: "",
                usertype: [],
                typeofuser: [],
                iconName: "",
                submenustatus: { label: 'Active', value: 1 },
                applicationType: 1,
            });
        },
    },
};
</script>
